var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1667 20C17.3883 20 20 17.3883 20 14.1667C20 10.945 17.3883 8.33333 14.1667 8.33333C10.945 8.33333 8.33333 10.945 8.33333 14.1667C8.33333 17.3883 10.945 20 14.1667 20ZM14.1667 19.1667C16.9281 19.1667 19.1667 16.9281 19.1667 14.1667C19.1667 11.4052 16.9281 9.16667 14.1667 9.16667C11.4052 9.16667 9.16667 11.4052 9.16667 14.1667C9.16667 16.9281 11.4052 19.1667 14.1667 19.1667Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.5625C0 0.757576 0.748143 0 1.51515 0H15.1515C15.9185 0 16.6667 0.757576 16.6667 1.51515V8.89469C16.423 8.77892 16.17 8.67955 15.9091 8.59801V1.51515C15.9091 1.13636 15.5303 0.757576 15.1515 0.757576H1.51515C1.13636 0.757576 0.757576 1.13636 0.757576 1.51515V15.1515C0.757576 15.5303 1.13636 15.9091 1.51515 15.9091H8.59801C8.67955 16.17 8.77892 16.423 8.89469 16.6667H1.51515C0.757576 16.6667 0 15.9186 0 15.1515V1.5625Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1515 8.41612C14.8314 8.36168 14.5023 8.33333 14.1667 8.33333C13.1399 8.33333 12.1751 8.59861 11.3371 9.06435L10.6061 8.33333L9.09091 9.84848L6.81818 6.81818L1.51515 12.8788V2.27273C1.51515 1.89394 1.89394 1.51515 2.27273 1.51515H14.3939C14.7727 1.51515 15.1515 1.89394 15.1515 2.27273V8.41612ZM11.9792 5.72917C12.8421 5.72917 13.5417 5.02961 13.5417 4.16667C13.5417 3.30372 12.8421 2.60417 11.9792 2.60417C11.1162 2.60417 10.4167 3.30372 10.4167 4.16667C10.4167 5.02961 11.1162 5.72917 11.9792 5.72917Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10.8333H15V17.5H13.3333V10.8333Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 13.3333H17.5V15H10.8333V13.3333Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/AddImage.4cee54d2346473ddfede2cfc7c047f12.svg";
export { ForwardRef as ReactComponent };